import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import "../../../assets/topstudio/styles/Player.css";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import axiosInstance from "../../../utils/axiosInstance";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";

import Volume from "./Volume";
import CenterCardRules from "./pop-up/centercard-rules.jsx";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import Teenpattit20Result from "../../client/tp-studio/tp-result/Teenpattit20-Result.jsx";
import { isMobile } from "react-device-detect";
import CenterCardResult from "./tp-result/CenterCardResult.jsx";

import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";

export default function CenterCardVirtual() {
  const dispatch = useDispatch();
  const [stakeLimit, setStakeLimit] = useState(0);
  const [showRules, setShowRules] = useState(false);
  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [resultList, setResultList] = useState([]);
  const [displayLoader, setDisplayLoader] = useState(true);
  const [activeTabIndex, setActiveTabIndex] = useState(1);

  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [open, setOpen] = useState(false);

  const [centerCardYes, setCenterCardYes] = useState(0);
  const [centerCardNo, setCenterCardNo] = useState(0);

  const [centerCardEven, setCenterCardEven] = useState(0);
  const [centerCardOdd, setCenterCardOdd] = useState(0);

  const [leftCardEven, setLeftCardEven] = useState(0);
  const [leftCardOdd, setLeftCardOdd] = useState(0);

  const [rightCardEven, setRightCardEven] = useState(0);
  const [rightCardOdd, setRightCardOdd] = useState(0);

  const [centerRed, setCenterRed] = useState(0);
  const [centerBlack, setCenterBlack] = useState(0);

  const [leftRed, setLeftRed] = useState(0);
  const [leftBlack, setLeftBlack] = useState(0);

  const [rightRed, setRightRed] = useState(0);
  const [rightBlack, setRightBlack] = useState(0);

  const [suspend1, setSuspend1] = useState(1);
  const [roundId, setRoundId] = useState("");
  const [lastStatus, setLastStatus] = useState(null);

  const [centerCardYesBook, setCenterCardYesBook] = useState(0);
  const [centerCardNoBook, setCenterCardNoBook] = useState(0);

  const [centerCardEvenBook, setCenterCardEvenBook] = useState(0);
  const [centerCardOddBook, setCenterCardOddBook] = useState(0);
  const [leftCardEvenBook, setLeftCardEvenBook] = useState(0);
  const [leftCardOddBook, setLeftCardOddBook] = useState(0);
  const [rightCardEvenBook, setRightCardEvenBook] = useState(0);
  const [rightCardOddBook, setRightCardOddBook] = useState(0);

  const [centerCardRedBook, setCenterCardRedBook] = useState(0);
  const [centerCardBlackBook, setCenterCardBlackBook] = useState(0);

  const [leftCardRedBook, setLeftCardRedBook] = useState(0);
  const [leftCardBlackBook, setLeftCardBlackBook] = useState(0);

  const [rightCardRedBook, setRightCardRedBook] = useState(0);
  const [rightCardBlackBook, setRightCardBlackBook] = useState(0);

  /* ================= TIMER ================= */
  const TOTAL_SECONDS = 30;
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
  const localTimerRef = useRef(null);

  /* ================= SEQUENTIAL CARD REVEAL ================= */
  const flipTimerRef = useRef(null);
  const revealStartedForRef = useRef(null);
  const [shownC1, setShownC1] = useState("1");
  const [shownC2, setShownC2] = useState("1");
  const [shownC3, setShownC3] = useState("1");

  /* ================= SOCKET ================= */
  const { data } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "centercard_virtual"
  });
  console.log("Socket data:", data);

  const payload = data?.data?.data;

  const isWinner = (value) => Number(value) === 1;
  const centerYesWinner = Number(payload?.result) === 1;
  const centerNoWinner = Number(payload?.result) === 2;
  isWinner(payload?.CenterBlack)
  isWinner(payload?.CenterEven)
  isWinner(payload?.CenterOdd)
  isWinner(payload?.CenterRed)

  isWinner(payload?.LeftBlack)
  isWinner(payload?.LeftEven)
  isWinner(payload?.LeftOdd)
  isWinner(payload?.LeftRed)

  isWinner(payload?.RightBlack)
  isWinner(payload?.RightEven)
  isWinner(payload?.RightOdd)
  isWinner(payload?.RightRed)

  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  const payloadResult = data?.data?.result;
  console.log("data:", payload); // DO NOT REMOVE
  console.log("result:", payloadResult);
  /* ================= TIMER + VALUES ================= */

  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  useEffect(() => {
    if (!payload) return;

    setDisplayLoader(false);
    updateUserData(data?.user);

    if (lastStatus !== payload.evt_status && payload.evt_status === "OPEN") {
      setPlacedBets([]);
      setCenterCardYesBook(0);
      setCenterCardNoBook(0);
      setCenterCardEvenBook(0);
      setCenterCardOddBook(0);
      setLeftCardEvenBook(0);
      setLeftCardOddBook(0);
      setRightCardEvenBook(0);
      setRightCardOddBook(0);
      setCenterCardRedBook(0);
      setCenterCardBlackBook(0);
      setLeftCardRedBook(0);
      setLeftCardBlackBook(0);
      setRightCardRedBook(0);
      setRightCardBlackBook(0);
    }

    if (lastStatus !== payload.evt_status) {
      setLastStatus(payload.evt_status);
    }

    setCenterCardYes(payload?.b1);
    setCenterCardNo(payload?.b2);

    setCenterRed(payload?.b13);
    setCenterBlack(payload?.b13);
    setLeftRed(payload?.b13);
    setLeftBlack(payload?.b13);
    setRightRed(payload?.b13);
    setRightBlack(payload?.b13);

    setCenterCardEven(payload?.b10);
    setCenterCardOdd(payload?.b11);

    setLeftCardEven(payload?.b10);
    setLeftCardOdd(payload?.b11);

    setRightCardEven(payload?.b10);
    setRightCardOdd(payload?.b11);

    setSuspend1(payload?.suspend1);
    setRoundId(payload?.cat_mid);

    const serverSeconds = payload?.left_time;
    if (typeof serverSeconds === "number") {
      setTimeLeft(serverSeconds);
    }

    clearInterval(localTimerRef.current);
    localTimerRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
  }, [payload]);

  async function getBook() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-book", {
      cat_mid: payload.cat_mid,
      gametype: "centercard_virtual",
      market_type: "m"
    });

    let dataList = res.data;
    if (dataList.length > 0) {
      for (let i = 0; i < dataList.length; i++) {
        let obj = dataList[i];
        if (obj != "") {
          setCenterCardYesBook(obj.rnr1s);
          setCenterCardNoBook(obj.rnr2s);
        }
      }
    }

    const resFancy = await axiosInstance.post("/casino/get-book", {
      cat_mid: payload.cat_mid,
      gametype: "centercard_virtual",
      market_type: "f"
    });
    let dataListFancy = resFancy.data;
    if (dataListFancy.length > 0) {
      for (let i = 0; i < dataListFancy.length; i++) {
        let obj = dataListFancy[i];

        if (obj.rnr_nam == "center even") {
          setCenterCardEvenBook(obj.lay);
        } else if (obj.rnr_nam == "center odd") {
          setCenterCardOddBook(obj.lay);
        } else if (obj.rnr_nam == "left even") {
          setLeftCardEvenBook(obj.lay);
        } else if (obj.rnr_nam == "left odd") {
          setLeftCardOddBook(obj.lay);
        } else if (obj.rnr_nam == "right even") {
          setRightCardEvenBook(obj.lay);
        } else if (obj.rnr_nam == "right odd") {
          setRightCardOddBook(obj.lay);
        } else if (obj.rnr_nam == "center red") {
          setCenterCardRedBook(obj.lay);
        } else if (obj.rnr_nam == "center black") {
          setCenterCardBlackBook(obj.lay);
        } else if (obj.rnr_nam == "left red") {
          setLeftCardRedBook(obj.lay);
        } else if (obj.rnr_nam == "left black") {
          setLeftCardBlackBook(obj.lay);
        } else if (obj.rnr_nam == "right red") {
          setRightCardRedBook(obj.lay);
        } else if (obj.rnr_nam == "right black") {
          setRightCardBlackBook(obj.lay);
        }
      }
    }
  }

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      showResultDetail();
    }
  };

  useEffect(() => () => clearInterval(localTimerRef.current), []);

  /* ================= SEQUENTIAL CARD REVEAL ================= */
  useEffect(() => {
    if (!payload?.evt_status) return;

    if (payload.evt_status === "OPEN") {
      clearTimeout(flipTimerRef.current);
      revealStartedForRef.current = null;
      setShownC1("1");
      setShownC2("1");
      setShownC3("1");
      return;
    }

    if (payload.evt_status === "CLOSED") {
      const c1 = payload?.c1;
      const c2 = payload?.c2;
      const c3 = payload?.c3;

      // Wait until at least the first card is available
      if (!c1 || c1 === "1") return;

      // Only start the reveal once per round (keyed on c1)
      const roundKey = `${c1}|${c2}|${c3}`;
      if (revealStartedForRef.current === roundKey) return;
      revealStartedForRef.current = roundKey;

      clearTimeout(flipTimerRef.current);
      setShownC1("1");
      setShownC2("1");
      setShownC3("1");

      let cancelled = false;

      // Order: Left (c1) → Right (c2) → Center (c3)
      function revealLeft() {
        if (cancelled) return;
        setShownC1(c1);
        flipTimerRef.current = setTimeout(revealRight, 1000);
      }
      function revealRight() {
        if (cancelled) return;
        setShownC2(c2);
        flipTimerRef.current = setTimeout(revealCenter, 1000);
      }
      function revealCenter() {
        if (cancelled) return;
        setShownC3(c3);
      }

      flipTimerRef.current = setTimeout(revealLeft, 300);

      return () => {
        cancelled = true;
        clearTimeout(flipTimerRef.current);
      };
    }
  }, [payload?.evt_status, payload?.c1, payload?.c2, payload?.c3]);

  useEffect(() => () => clearTimeout(flipTimerRef.current), []);

  /* ================= SVG TIMER ================= */
  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  /* ================= BET SLIP ================= */
  const showBetfairBetSlip = (
    bettype,
    teamname,
    selectRnr,
    price,
    marketTypeVal,
    sid
  ) => {
    let obj = {
      amount: 0,
      catmid: payload?.cat_mid,
      round: payload?.cat_mid,
      odds: price,
      teamname,
      bettype,
      selectRnr,
      marketVal: 1,
      game_type: 7,
      game_name: "centercard_virtual",
      market_type: marketTypeVal,
      sid: sid
    };

    setPlaceBetObject(obj);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
  };

  const closeBetSlip = () => setShowBetSlip(false);
  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  const [profileData, setProfileData] = useState(null);
  const [placedBets, setPlacedBets] = useState([]);
  const [initialBetsFetched, setInitialBetsFetched] = useState(false);

  const fetchProfile = async () => {
    const { data } = await axiosInstance.get("/profile");
    setProfileData(data);
  };


  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  async function getPlacedBets() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-placed-bets", {
      cat_mid: payload.cat_mid,
      gametype: "centercard_virtual"
    });
    setPlacedBets(res.data);
  }

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
  }, []);

  useEffect(() => {
    if (!initialBetsFetched && payload?.cat_mid) {
      getPlacedBets();
      getBook();
      setInitialBetsFetched(true);
    }
  }, [payload]);

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;
    // placeBetObject.sid1 = payload?.sid1;
    // placeBetObject.sid2 = payload?.sid2;
    // placeBetObject.sid3 = payload?.sid3;

    try {
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );

      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
          setShowBetSlipPopup(false);
          getPlacedBets();
          getBook();
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };

  const displayRunnerName = (runnerName) => {
    return runnerName
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const [resultData, setResultData] = useState([]);

  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "centercard_virtual";

    //console.log("BEFORE API CALL");

    const response = await axiosInstance.post("/teenpatti-results", resultObj);

    //console.log("FULL RESPONSE", response.data);
    response.data.results_list.forEach((item, i) => {
      //console.log(i, item.evt_status, item.result, item.c1, item.c2, item.c3);
    });
    //console.log("ac1:", response.data.results_list[0].ac1);
    //console.log("ac2:", response.data.results_list[0].ac2);
    //console.log("ac3:", response.data.results_list[0].ac3);

    //console.log("bc1:", response.data.results_list[0].bc1);
    //console.log("bc2:", response.data.results_list[0].bc2);
    //console.log("bc3:", response.data.results_list[0].bc3);

    //console.log("cards_desc:", response.data.results_list[0].cards_desc);
    //console.log("AFTER API CALL");
    setResultData(response.data.results_list);
    //console.log("response->", resultData);
  };

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  //console.log("resultList:", resultList);

  return (
    <div className="aviator-scope player-scope aviator-bg-black">
      <ClientLayoutWithOutHeader showLoader={false}>
        <div class="details-tabs-wrapper1">
          <div className="main-page">
            <div className="row no-gutters">
              <div className="col-md-12">
                <div className="bodyheight">
                  <div className="wrapper">
                    <TPStudioSidebar open={open} />
                  </div>

                  <div className="lobby-ctn BPGmaindiv">
                    <TpStudioHeader setOpen={setOpen} open={open} />
                    <TpStudioLoader displayLoader={displayLoader} />
                  </div>

                  <div
                    className="row"
                    style={{ display: displayLoader ? "none" : "" }}
                  >
                    <div className="col-md-8">
                      <div className="left-content">
                        <div>
                          {" "}
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer h-45">
                            <div className="col-6 col-md-6 titlebarname  inline-block Gameidcol mt-2">
                              <p>CENTER CARD</p>
                            </div>
                            <div
                              className="col-6 col-md-6 inline-block Gameidcol text-right"
                              style={{ marginTop: "4px" }}
                            >
                              <div
                                role="group"
                                aria-label="Second group"
                                className="btn-group btn-group-sm mr-2"
                              >
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  id="Alltab"
                                  className={
                                    activeTabIndex == 1
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(1)}
                                >
                                  Game
                                </button>
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  id="RESULTStab"
                                  className={
                                    activeTabIndex == 2
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(2)}
                                >
                                  Results
                                </button>
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  className="tablink btn btn-primary"
                                  onClick={() => setShowRules(true)}
                                >
                                  Rules
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="cards-layout blackjack"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div>
                            <div
                              className="cards-layout blackjack"
                              style={{ position: "relative" }}
                            >
                              <div className="col-12 timerDiv2 mb-negative-24">
                                <CenterCardRules
                                  show={showRules}
                                  onClose={() => setShowRules(false)}
                                />

                                <div
                                  className="row mt-2"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  <div className="col-2 col-md-1">
                                    <div className="Connectedclients mt-1">
                                      <i
                                        aria-hidden="true"
                                        className="fa fa-user mr-1"
                                        style={{
                                          fontSize: "14px",
                                          color: "white"
                                        }}
                                      />
                                      <b>
                                        <span
                                          id="UsersCount"
                                          className="number"
                                        >
                                          53
                                        </span>
                                      </b>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className="col-md-8"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                />

                                <div
                                  className="col-md-2"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  {/* Timer with animated stroke + numeric countdown */}
                                  <div className="teenpatti-base-timer">
                                    <svg
                                      viewBox="0 0 100 100"
                                      className="base-timer__svg"
                                    >
                                      <g className="base-timer__circle">
                                        <circle
                                          cx="50"
                                          cy="50"
                                          r="45"
                                          className="base-timer__path-elapsed"
                                        />
                                        <path
                                          strokeDasharray={`${Math.round(
                                            dash
                                          )} ${Math.round(CIRC)}`}
                                          className={`base-timer__path-remaining ${timerColor}`}
                                          d="
                                            M 50, 50
                                            m -45, 0
                                            a 45,45 0 1,0 90,0
                                            a 45,45 0 1,0 -90,0
                                          "
                                        />
                                      </g>
                                    </svg>
                                    <span className="base-timer__label">
                                      {timeLeft == 1 ? 0 : timeLeft}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="three-cards-wrapper">
                                {/* Left card — revealed first */}
                                <div class="player-containerHC">
                                  <div class="player-itemHC">
                                    <span class="player-nameHC">Left</span>
                                    <div class="player-cardHC">
                                      <div
                                        id="BFBCardFanView"
                                        class="card-viewHC"
                                      >
                                        <img
                                          src={`/assets/images/cards/${shownC1}.svg`}
                                          draggable={false}
                                          style={{
                                            width: isMobile ? "46px" : "70px",
                                            height: isMobile ? "55px" : "85px"
                                          }}
                                          className="animate__animated animate__flipInY"
                                          key={shownC1}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* Center card — revealed last */}
                                <div class="player-containerHC">
                                  <div class="player-itemHC">
                                    <span class="player-nameHC">Center</span>
                                    <div class="player-cardHC">
                                      <img
                                        src={`/assets/images/cards/${shownC3}.svg`}
                                        draggable={false}
                                        style={{
                                          width: isMobile ? "46px" : "70px",
                                          height: isMobile ? "55px" : "85px"
                                        }}
                                        className="animate__animated animate__flipInY"
                                        key={shownC3}
                                      />
                                    </div>
                                  </div>
                                </div>

                                {/* Right card — revealed second */}
                                <div class="player-containerHC">
                                  <div class="player-itemHC">
                                    <span class="player-nameHC">Right</span>
                                    <div class="player-cardHC">
                                      <img
                                        src={`/assets/images/cards/${shownC2}.svg`}
                                        draggable={false}
                                        style={{
                                          width: isMobile ? "46px" : "70px",
                                          height: isMobile ? "55px" : "85px"
                                        }}
                                        className="animate__animated animate__flipInY"
                                        key={shownC2}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <Volume
                                id="CenterCardSoundcontrol"
                                style={{
                                  position: "absolute",
                                  right: 8,
                                  bottom: 8,
                                  zIndex: 100,
                                  display: activeTabIndex == 1 ? "" : "none"
                                }}
                              />
                              {/* Controls removed (auto mode) */}
                            </div>
                          </div>
                        </div>

                        {/* Footer */}

                        <div
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                            <div className="video-button">
                              {Object.keys(resultList).map((idx) => (
                                <button
                                  key={idx}
                                  className="video-button result-button border-gradient-btn border-gradient-purple-btn"
                                >
                                  {resultList[idx]}
                                </button>
                              ))}
                            </div>
                            <div className="round-div">
                              <div className="label">Round ID:</div>
                              <div className="id">{roundId}</div>
                            </div>
                          </div>
                        </div>

                        {/* Market Sections (unchanged) */}
                        <div
                          className="bg-white"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div
                            className="tb-content"
                            style={{ background: "#fff" }}
                          >
                            <div class="market-titlebar">
                              <p class="market-name">
                                <span class="market-name-badge">
                                  <i class="market-name-icon">
                                    <img
                                      src="/assets/images/time-img.png"
                                      style={{
                                        filter: "invert(100%)",
                                        marginTop: "-8px",
                                        marginLeft: "-1px"
                                      }}
                                    />
                                  </i>
                                  <span>MATCH ODDS </span>
                                </span>
                              </p>
                              <div class="market-overarround">
                                <span></span>
                                <strong>Back</strong>
                              </div>
                              <div class="market-overarround market-overarround-lay">
                                <strong>Lay</strong>
                              </div>
                            </div>
                            <div class="market-runners">
                              <div class="runner-runner">
                                <h3
                                  class="runner-name"
                                  id="b1Sucess"
                                  style={{
                                    backgroundColor: centerYesWinner
                                      ? "#b5ff70"
                                      : ""
                                  }}
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <div>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Center-Yes
                                                </h4>
                                              </div>
                                            </td>
                                          </tr>

                                          <tr>
                                            <td>
                                              <div
                                                style={{
                                                  float: "left",
                                                  display:
                                                    centerCardYesBook != 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    centerCardYesBook > 0
                                                      ? "green"
                                                      : "red"
                                                }}
                                              >
                                                {formatTruncate(
                                                  centerCardYesBook
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>

                                <div class="price-row-box-new">
                                  <div
                                    class={
                                      isSuspended
                                        ? "runner-disabled2 suspendCls"
                                        : "runner-disabled2 suspendCls hides"
                                    }
                                  >
                                    {suspendedText}
                                  </div>
                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a
                                    class="price-price price-back mb-show span3details"
                                    data-teamname="center yes"
                                    data-market-type="m"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "center yes",
                                        "center yes",
                                        centerCardYes,
                                        "m",
                                        1
                                      )
                                    }
                                  >
                                    <div id="rnr1" class="sus_cls">
                                      <span
                                        class="price-odd odd"
                                        id="runnerdragonspan"
                                      >
                                        {centerCardYes}
                                      </span>
                                      <span class="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </div>
                                  </a>

                                  <a class="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div class="runner-runner">
                                <h3
                                  class="runner-name"
                                  id="b2Sucess"
                                  style={{
                                    backgroundColor: centerNoWinner
                                      ? "#b5ff70"
                                      : ""
                                  }}
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <div
                                                style={{
                                                  backgroundColor:
                                                    centerNoWinner
                                                      ? "#b5ff70"
                                                      : ""
                                                }}
                                              >
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Center-No
                                                </h4>
                                              </div>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="book2"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    centerCardNoBook != 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    centerCardNoBook > 0
                                                      ? "green"
                                                      : "red"
                                                }}
                                              >
                                                {formatTruncate(
                                                  centerCardNoBook
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>

                                <div class="price-row-box-new">
                                  <div
                                    class={
                                      isSuspended
                                        ? "runner-disabled2 suspendCls"
                                        : "runner-disabled2 suspendCls hides"
                                    }
                                  >
                                    {suspendedText}
                                  </div>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a
                                    class="price-price price-back mb-show span3details"
                                    data-teamname="center no"
                                    data-market-type="m"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "center no",
                                        "center no",
                                        centerCardNo,
                                        "m",
                                        1
                                      )
                                    }
                                  >
                                    <div id="rnr2" class="sus_cls">
                                      <span
                                        class="price-odd odd"
                                        id="runnertigerspan"
                                      >
                                        {centerCardNo}
                                      </span>
                                      <span class="price-amount" id="rate2">
                                        {stakeLimit}
                                      </span>
                                    </div>
                                  </a>

                                  <a class="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            style={{ height: "5px", backgroundColor: "#000" }}
                          ></div>

                          <div
                            className="tb-content"
                            style={{ background: "#fff" }}
                          >
                            <div class="market-titlebar">
                              <p class="market-name">
                                <span class="market-name-badge">
                                  <i class="market-name-icon">
                                    <img
                                      src="/assets/images/time-img.png"
                                      style={{
                                        filter: "invert(100%)",
                                        marginTop: "-8px",
                                        marginLeft: "-1px"
                                      }}
                                    />
                                  </i>
                                  <span>CENTER ODD-EVEN </span>
                                </span>
                              </p>
                              <div class="market-overarround">
                                <span></span>
                                <strong>Back</strong>
                              </div>
                              <div class="market-overarround market-overarround-lay">
                                <strong>Lay</strong>
                              </div>
                            </div>
                            <div class="market-runners">
                              <div class="runner-runner">
                                <h3
                                  class="runner-name"
                                  id="b5Sucess"
                                  style={{
                                    backgroundColor: isWinner(
                                      payload?.CenterEven
                                    )
                                      ? "#b5ff70"
                                      : ""
                                  }}
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                                class="clippable-spacer"
                                              >
                                                Center - Even
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="book5"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    centerCardEvenBook != 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    centerCardEvenBook > 0
                                                      ? "green"
                                                      : "red"
                                                }}
                                              >
                                                {formatTruncate(
                                                  centerCardEvenBook
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>

                                <div class="price-row-box-new">
                                  <div
                                    class={
                                      isSuspended
                                        ? "runner-disabled2 suspendCls"
                                        : "runner-disabled2 suspendCls hides"
                                    }
                                  >
                                    {suspendedText}
                                  </div>
                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a
                                    class="price-price price-back mb-show span3details"
                                    data-market-type="f"
                                    data-teamname="center even"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "center even",
                                        "center even",
                                        centerCardEven,
                                        "f",
                                        1
                                      )
                                    }
                                  >
                                    <div id="rnr5" class="sus_cls">
                                      <span
                                        class="price-odd odd"
                                        id="runnercenterevenspan"
                                      >
                                        {centerCardEven}
                                      </span>
                                      <span class="price-amount" id="rate5">
                                        {stakeLimit}
                                      </span>
                                    </div>
                                  </a>

                                  <a class="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div class="runner-runner">
                                <h3
                                  class="runner-name"
                                  id="b6Sucess"
                                  style={{
                                    backgroundColor: isWinner(
                                      payload?.CenterOdd
                                    )
                                      ? "#b5ff70"
                                      : ""
                                  }}
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                                class="clippable-spacer"
                                              >
                                                Center - Odd
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="book6"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    centerCardOddBook != 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    centerCardOddBook > 0
                                                      ? "green"
                                                      : "red"
                                                }}
                                              >
                                                {formatTruncate(
                                                  centerCardOddBook
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>

                                <div class="price-row-box-new">
                                  <div
                                    class={
                                      isSuspended
                                        ? "runner-disabled2 suspendCls"
                                        : "runner-disabled2 suspendCls hides"
                                    }
                                  >
                                    {suspendedText}
                                  </div>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a
                                    class="price-price price-back mb-show span3details"
                                    data-market-type="f"
                                    data-teamname="center odd"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "center odd",
                                        "center odd",
                                        centerCardOdd,
                                        "f",
                                        1
                                      )
                                    }
                                  >
                                    <div id="rnr6" class="sus_cls">
                                      <span
                                        class="price-odd odd"
                                        id="runnercenteroddspan"
                                      >
                                        {centerCardOdd}
                                      </span>
                                      <span class="price-amount" id="rate6">
                                        {stakeLimit}
                                      </span>
                                    </div>
                                  </a>

                                  <a class="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            style={{ height: "5px", backgroundColor: "#000" }}
                          ></div>

                          <div
                            className="tb-content"
                            style={{ background: "#fff" }}
                          >
                            <div class="market-titlebar">
                              <p class="market-name">
                                <span class="market-name-badge">
                                  <i class="market-name-icon">
                                    <img
                                      src="/assets/images/time-img.png"
                                      style={{
                                        filter: "invert(100%)",
                                        marginTop: "-8px",
                                        marginLeft: "-1px"
                                      }}
                                    />
                                  </i>
                                  <span>LEFT ODD-EVEN </span>
                                </span>
                              </p>
                              <div class="market-overarround">
                                <span></span>
                                <strong>Back</strong>
                              </div>
                              <div class="market-overarround market-overarround-lay">
                                <strong>Lay</strong>
                              </div>
                            </div>
                            <div class="market-runners">
                              <div class="runner-runner">
                                <h3
                                  class="runner-name"
                                  id="b22Sucess"
                                  style={{
                                    backgroundColor: isWinner(payload?.LeftEven)
                                      ? "#b5ff70"
                                      : ""
                                  }}
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                                class="clippable-spacer"
                                              >
                                                Left - Even
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="book22"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    leftCardEvenBook != 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    leftCardEvenBook > 0
                                                      ? "green"
                                                      : "red"
                                                }}
                                              >
                                                {formatTruncate(
                                                  leftCardEvenBook
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>

                                <div class="price-row-box-new">
                                  <div
                                    class={
                                      isSuspended
                                        ? "runner-disabled2 suspendCls"
                                        : "runner-disabled2 suspendCls hides"
                                    }
                                  >
                                    {suspendedText}
                                  </div>
                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a
                                    class="price-price price-back mb-show span3details"
                                    data-market-type="f"
                                    data-teamname="left even"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "left even",
                                        "left even",
                                        leftCardEven,
                                        "f",
                                        1
                                      )
                                    }
                                  >
                                    <div id="rnr22" class="sus_cls">
                                      <span
                                        class="price-odd odd"
                                        id="runnerleftevenspan"
                                      >
                                        {leftCardEven}
                                      </span>
                                      <span class="price-amount" id="rate22">
                                        {stakeLimit}
                                      </span>
                                    </div>
                                  </a>

                                  <a class="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div class="runner-runner">
                                <h3
                                  class="runner-name"
                                  id="b23Sucess"
                                  style={{
                                    backgroundColor: isWinner(payload?.LeftOdd)
                                      ? "#b5ff70"
                                      : ""
                                  }}
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                                class="clippable-spacer"
                                              >
                                                Left - Odd
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="book23"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    leftCardOddBook != 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    leftCardOddBook > 0
                                                      ? "green"
                                                      : "red"
                                                }}
                                              >
                                                {formatTruncate(
                                                  leftCardOddBook
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>

                                <div class="price-row-box-new">
                                  <div
                                    class={
                                      isSuspended
                                        ? "runner-disabled2 suspendCls"
                                        : "runner-disabled2 suspendCls hides"
                                    }
                                  >
                                    {suspendedText}
                                  </div>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a
                                    class="price-price price-back mb-show span3details"
                                    data-market-type="f"
                                    data-teamname="left odd"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "left odd",
                                        "left odd",
                                        leftCardOdd,
                                        "f",
                                        1
                                      )
                                    }
                                  >
                                    <div id="rnr23" class="sus_cls">
                                      <span
                                        class="price-odd odd"
                                        id="runnerleftoddspan"
                                      >
                                        {leftCardOdd}
                                      </span>
                                      <span class="price-amount" id="rate23">
                                        {stakeLimit}
                                      </span>
                                    </div>
                                  </a>

                                  <a class="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            style={{ height: "5px", backgroundColor: "#000" }}
                          ></div>

                          <div
                            className="tb-content"
                            style={{ background: "#fff" }}
                          >
                            <div class="market-titlebar">
                              <p class="market-name">
                                <span class="market-name-badge">
                                  <i class="market-name-icon">
                                    <img
                                      src="/assets/images/time-img.png"
                                      style={{
                                        filter: "invert(100%)",
                                        marginTop: "-8px",
                                        marginLeft: "-1px"
                                      }}
                                    />
                                  </i>
                                  <span>Right ODD-EVEN </span>
                                </span>
                              </p>
                              <div class="market-overarround">
                                <span></span>
                                <strong>Back</strong>
                              </div>
                              <div class="market-overarround market-overarround-lay">
                                <strong>Lay</strong>
                              </div>
                            </div>
                            <div class="market-runners">
                              <div class="runner-runner">
                                <h3
                                  class="runner-name"
                                  id="b26Sucess"
                                  style={{
                                    backgroundColor: isWinner(
                                      payload?.RightEven
                                    )
                                      ? "#b5ff70"
                                      : ""
                                  }}
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                                class="clippable-spacer"
                                              >
                                                Right - Even
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="book26"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    rightCardEvenBook != 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    rightCardEvenBook > 0
                                                      ? "green"
                                                      : "red"
                                                }}
                                              >
                                                {formatTruncate(
                                                  rightCardEvenBook
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>

                                <div class="price-row-box-new">
                                  <div
                                    class={
                                      isSuspended
                                        ? "runner-disabled2 suspendCls"
                                        : "runner-disabled2 suspendCls hides"
                                    }
                                  >
                                    {suspendedText}
                                  </div>
                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a
                                    class="price-price price-back mb-show span3details"
                                    data-market-type="f"
                                    data-teamname="right even"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "right even",
                                        "right even",
                                        rightCardEven,
                                        "f",
                                        1
                                      )
                                    }
                                  >
                                    <div id="rnr26" class="sus_cls">
                                      <span
                                        class="price-odd odd"
                                        id="runnerrightevenspan"
                                      >
                                        {rightCardEven}
                                      </span>
                                      <span class="price-amount" id="rate26">
                                        {stakeLimit}
                                      </span>
                                    </div>
                                  </a>

                                  <a class="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div class="runner-runner">
                                <h3
                                  class="runner-name"
                                  id="b27Sucess"
                                  style={{
                                    backgroundColor: isWinner(payload?.RightOdd)
                                      ? "#b5ff70"
                                      : ""
                                  }}
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                                class="clippable-spacer"
                                              >
                                                Right - Odd
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="book27"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    rightCardOddBook != 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    rightCardOddBook > 0
                                                      ? "green"
                                                      : "red"
                                                }}
                                              >
                                                {formatTruncate(
                                                  rightCardOddBook
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>

                                <div class="price-row-box-new">
                                  <div
                                    class={
                                      isSuspended
                                        ? "runner-disabled2 suspendCls"
                                        : "runner-disabled2 suspendCls hides"
                                    }
                                  >
                                    {suspendedText}
                                  </div>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a
                                    class="price-price price-back mb-show span3details"
                                    data-market-type="f"
                                    data-teamname="right odd"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "right odd",
                                        "right odd",
                                        rightCardOdd,
                                        "f",
                                        1
                                      )
                                    }
                                  >
                                    <div id="rnr27" class="sus_cls">
                                      <span
                                        class="price-odd odd"
                                        id="runnerrightoddspan"
                                      >
                                        {rightCardOdd}
                                      </span>
                                      <span class="price-amount" id="rate27">
                                        {stakeLimit}
                                      </span>
                                    </div>
                                  </a>

                                  <a class="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            style={{ height: "5px", backgroundColor: "#000" }}
                          ></div>

                          <div
                            className="tb-content"
                            style={{ background: "#fff" }}
                          >
                            <div class="market-titlebar">
                              <p class="market-name">
                                <span class="market-name-badge">
                                  <i class="market-name-icon">
                                    <img
                                      src="/assets/images/time-img.png"
                                      style={{
                                        filter: "invert(100%)",
                                        marginTop: "-8px",
                                        marginLeft: "-1px"
                                      }}
                                    />
                                  </i>
                                  <span>CENTER COLOR </span>
                                </span>
                              </p>
                              <div class="market-overarround">
                                <span></span>
                                <strong>Back</strong>
                              </div>
                              <div class="market-overarround market-overarround-lay">
                                <strong>Lay</strong>
                              </div>
                            </div>
                            <div class="market-runners">
                              <div class="runner-runner">
                                <h3
                                  class="runner-name"
                                  id="b7Sucess"
                                  style={{
                                    backgroundColor: isWinner(
                                      payload?.CenterRed
                                    )
                                      ? "#b5ff70"
                                      : ""
                                  }}
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                                class="clippable-spacer"
                                              >
                                                Center - Red
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="book7"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    centerCardRedBook != 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    centerCardRedBook > 0
                                                      ? "green"
                                                      : "red"
                                                }}
                                              >
                                                {formatTruncate(
                                                  centerCardRedBook
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>

                                <div class="price-row-box-new">
                                  <div
                                    class={
                                      isSuspended
                                        ? "runner-disabled2 suspendCls"
                                        : "runner-disabled2 suspendCls hides"
                                    }
                                  >
                                    {suspendedText}
                                  </div>
                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a
                                    class="price-price price-back mb-show span3details"
                                    data-market-type="f"
                                    data-teamname="center red"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "center red",
                                        "center red",
                                        centerRed,
                                        "f",
                                        1
                                      )
                                    }
                                  >
                                    <div id="rnr7" class="sus_cls">
                                      <span
                                        class="price-odd odd"
                                        id="runnercenterredspan"
                                      >
                                        {centerRed}
                                      </span>
                                      <span class="price-amount" id="rate7">
                                        {stakeLimit}
                                      </span>
                                    </div>
                                  </a>

                                  <a class="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div class="runner-runner">
                                <h3
                                  class="runner-name"
                                  id="b8Sucess"
                                  style={{
                                    backgroundColor: isWinner(
                                      payload?.CenterBlack
                                    )
                                      ? "#b5ff70"
                                      : ""
                                  }}
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                                class="clippable-spacer"
                                              >
                                                Center - Black
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="book8"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    centerCardBlackBook != 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    centerCardBlackBook > 0
                                                      ? "green"
                                                      : "red"
                                                }}
                                              >
                                                {formatTruncate(
                                                  centerCardBlackBook
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>

                                <div class="price-row-box-new">
                                  <div
                                    class={
                                      isSuspended
                                        ? "runner-disabled2 suspendCls"
                                        : "runner-disabled2 suspendCls hides"
                                    }
                                  >
                                    {suspendedText}
                                  </div>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a
                                    class="price-price price-back mb-show span3details"
                                    data-market-type="f"
                                    data-teamname="center black"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "center black",
                                        "center black",
                                        centerBlack,
                                        "f",
                                        1
                                      )
                                    }
                                  >
                                    <div id="rnr8" class="sus_cls">
                                      <span
                                        class="price-odd odd"
                                        id="runnercenterblackspan"
                                      >
                                        {centerBlack}
                                      </span>
                                      <span class="price-amount" id="rate8">
                                        {stakeLimit}
                                      </span>
                                    </div>
                                  </a>

                                  <a class="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            style={{ height: "5px", backgroundColor: "#000" }}
                          ></div>

                          <div
                            className="tb-content"
                            style={{ background: "#fff" }}
                          >
                            <div class="market-titlebar">
                              <p class="market-name">
                                <span class="market-name-badge">
                                  <i class="market-name-icon">
                                    <img
                                      src="/assets/images/time-img.png"
                                      style={{
                                        filter: "invert(100%)",
                                        marginTop: "-8px",
                                        marginLeft: "-1px"
                                      }}
                                    />
                                  </i>
                                  <span>LEFT COLOR </span>
                                </span>
                              </p>
                              <div class="market-overarround">
                                <span></span>
                                <strong>Back</strong>
                              </div>
                              <div class="market-overarround market-overarround-lay">
                                <strong>Lay</strong>
                              </div>
                            </div>
                            <div class="market-runners">
                              <div class="runner-runner">
                                <h3
                                  class="runner-name"
                                  id="b24Sucess"
                                  style={{
                                    backgroundColor: isWinner(payload?.LeftRed)
                                      ? "#b5ff70"
                                      : ""
                                  }}
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                                class="clippable-spacer"
                                              >
                                                Left - Red
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="book24"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    leftCardRedBook != 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    leftCardRedBook > 0
                                                      ? "green"
                                                      : "red"
                                                }}
                                              >
                                                {formatTruncate(
                                                  leftCardRedBook
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>

                                <div class="price-row-box-new">
                                  <div
                                    class={
                                      isSuspended
                                        ? "runner-disabled2 suspendCls"
                                        : "runner-disabled2 suspendCls hides"
                                    }
                                  >
                                    {suspendedText}
                                  </div>
                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a
                                    class="price-price price-back mb-show span3details"
                                    data-market-type="f"
                                    data-teamname="left red"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "left red",
                                        "left red",
                                        leftRed,
                                        "f",
                                        1
                                      )
                                    }
                                  >
                                    <div id="rnr24" class="sus_cls">
                                      <span
                                        class="price-odd odd"
                                        id="runnerleftredspan"
                                      >
                                        {leftRed}
                                      </span>
                                      <span class="price-amount" id="rate24">
                                        {stakeLimit}
                                      </span>
                                    </div>
                                  </a>

                                  <a class="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div class="runner-runner">
                                <h3
                                  class="runner-name"
                                  id="b25Sucess"
                                  style={{
                                    backgroundColor: isWinner(
                                      payload?.LeftBlack
                                    )
                                      ? "#b5ff70"
                                      : ""
                                  }}
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                                class="clippable-spacer"
                                              >
                                                Left - Black
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="book25"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    leftCardBlackBook != 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    leftCardBlackBook > 0
                                                      ? "green"
                                                      : "red"
                                                }}
                                              >
                                                {formatTruncate(
                                                  leftCardBlackBook
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>

                                <div class="price-row-box-new">
                                  <div
                                    class={
                                      isSuspended
                                        ? "runner-disabled2 suspendCls"
                                        : "runner-disabled2 suspendCls hides"
                                    }
                                  >
                                    {suspendedText}
                                  </div>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a
                                    class="price-price price-back mb-show span3details"
                                    data-market-type="f"
                                    data-teamname="left black"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "left black",
                                        "left black",
                                        leftBlack,
                                        "f",
                                        1
                                      )
                                    }
                                  >
                                    <div id="rnr25" class="sus_cls">
                                      <span
                                        class="price-odd odd"
                                        id="runnerleftblackspan"
                                      >
                                        {leftBlack}
                                      </span>
                                      <span class="price-amount" id="rate25">
                                        {stakeLimit}
                                      </span>
                                    </div>
                                  </a>

                                  <a class="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            style={{ height: "5px", backgroundColor: "#000" }}
                          ></div>

                          <div
                            className="tb-content"
                            style={{ background: "#fff" }}
                          >
                            <div class="market-titlebar">
                              <p class="market-name">
                                <span class="market-name-badge">
                                  <i class="market-name-icon">
                                    <img
                                      src="/assets/images/time-img.png"
                                      style={{
                                        filter: "invert(100%)",
                                        marginTop: "-8px",
                                        marginLeft: "-1px"
                                      }}
                                    />
                                  </i>
                                  <span>RIGHT COLOR </span>
                                </span>
                              </p>
                              <div class="market-overarround">
                                <span></span>
                                <strong>Back</strong>
                              </div>
                              <div class="market-overarround market-overarround-lay">
                                <strong>Lay</strong>
                              </div>
                            </div>
                            <div class="market-runners">
                              <div class="runner-runner">
                                <h3
                                  class="runner-name"
                                  id="b28Sucess"
                                  style={{
                                    backgroundColor: isWinner(payload?.RightRed)
                                      ? "#b5ff70"
                                      : ""
                                  }}
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                                class="clippable-spacer"
                                              >
                                                Right - Red
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="book28"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    rightCardRedBook != 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    rightCardRedBook > 0
                                                      ? "green"
                                                      : "red"
                                                }}
                                              >
                                                {formatTruncate(
                                                  rightCardRedBook
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>

                                <div class="price-row-box-new">
                                  <div
                                    class={
                                      isSuspended
                                        ? "runner-disabled2 suspendCls"
                                        : "runner-disabled2 suspendCls hides"
                                    }
                                  >
                                    {suspendedText}
                                  </div>
                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a
                                    class="price-price price-back mb-show span3details"
                                    data-market-type="f"
                                    data-teamname="right red"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "right red",
                                        "right red",
                                        rightRed,
                                        "f",
                                        1
                                      )
                                    }
                                  >
                                    <div id="rnr28" class="sus_cls">
                                      <span
                                        class="price-odd odd"
                                        id="runnerrightredspan"
                                      >
                                        {rightRed}
                                      </span>
                                      <span class="price-amount" id="rate28">
                                        {stakeLimit}
                                      </span>
                                    </div>
                                  </a>

                                  <a class="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div class="runner-runner">
                                <h3
                                  class="runner-name"
                                  id="b29Sucess"
                                  style={{
                                    backgroundColor: isWinner(
                                      payload?.RightBlack
                                    )
                                      ? "#b5ff70"
                                      : ""
                                  }}
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                                class="clippable-spacer"
                                              >
                                                Right - Black
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="book29"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    rightCardBlackBook != 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    rightCardBlackBook > 0
                                                      ? "green"
                                                      : "red"
                                                }}
                                              >
                                                {formatTruncate(
                                                  rightCardBlackBook
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>

                                <div class="price-row-box-new">
                                  <div
                                    class={
                                      isSuspended
                                        ? "runner-disabled2 suspendCls"
                                        : "runner-disabled2 suspendCls hides"
                                    }
                                  >
                                    {suspendedText}
                                  </div>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a
                                    class="price-price price-back mb-show span3details"
                                    data-market-type="f"
                                    data-teamname="right black"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "right black",
                                        "right black",
                                        rightBlack,
                                        "f",
                                        1
                                      )
                                    }
                                  >
                                    <div id="rnr29" class="sus_cls">
                                      <span
                                        class="price-odd odd"
                                        id="runnerrightblackspan"
                                      >
                                        {rightBlack}
                                      </span>
                                      <span class="price-amount" id="rate29">
                                        {stakeLimit}
                                      </span>
                                    </div>
                                  </a>

                                  <a class="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          display: activeTabIndex == 2 ? "" : "none",
                          color: "white"
                        }}
                      >
                        <CenterCardResult resultData={resultData} />
                      </div>
                    </div>

                    <div className="col-md-4 mobile-margin">
                      {showBetSlipPopup && (
                        <TPPopUpBetSlip
                          closeBetSlipParent={closeBetSlipMobile}
                          betObj={placeBetObject}
                          placeBetParent={placeBet}
                          betButtonShow={betButtonShow}
                          betErrorMessageObj={betErrorMessageObj}
                          betButtonShowLoaderShow={betButtonShowLoaderShow}
                          profileData={profileData}
                        />
                      )}
                      <TeenPattisCasinoBetslipWeb
                        showBetSlip={showBetSlip}
                        placeBetObject={placeBetObject}
                        closeBetSlipParent={closeBetSlip}
                        placeBetParent={placeBet}
                        betErrorMessageObj={betErrorMessageObj}
                        profileData={profileData}
                      ></TeenPattisCasinoBetslipWeb>
                      <div>
                        <div className="bets">
                          <strong>
                            Matched Bets (0)
                            <img
                              src={reconnecting}
                              alt="dc"
                              className="rounded disconnected"
                              style={{ display: "none" }}
                            />{" "}
                          </strong>
                          <div className="betting-table">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Runner</th>
                                  <th>Price</th>
                                  <th>Size</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {placedBets.map((bet, index) => {
                                  console.log("MATCHED BET:", bet);

                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        background:
                                          bet.type == "b"
                                            ? "#e9f6fc"
                                            : "#fce3e4"
                                      }}
                                    >
                                      <td>
                                        {displayRunnerName(bet.rnr)} - (
                                        {bet.cat_mid})
                                      </td>

                                      <td>{bet.amnt}</td>
                                      <td>{bet.rate}</td>
                                      <td></td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ClientLayoutWithOutHeader>

      <style>
        {`

      @media (max-width:768px){
    .result-button:nth-child(n+6){
        display:none !important;
    }
}
            .player-containerHC {
            display: inline-flex;
            flex-direction: column;
            margin: 5px;
          }
          .three-cards-wrapper{
            display:flex;
            justify-content:center;
            align-items:flex-start;
            gap:1px;
            width:100%;
            margin-top: 30px;
          }
          .volume-wrapper {
            margin-top: -25px;
          }
          @media (min-width: 992px) {
            .aviator-scope .row {
              margin-left: 0 !important;
              margin-right: 0 !important;
            }
          }
          @scope (.aviator-scope) {
            .home-content {
              margin-top: 0 !important;
            }
            .timerDiv2 {
              padding-left: 5px;
              padding-top: 0;
            }
            .timerDiv2 .teenpatti-base-timer {
              position: relative;
              top: -4px;
              left: 8px;
            }
            .cards-layout.blackjack {
              position: relative;
              margin-top: 0;
              min-height: 210px;
              background: #000000 !important;
            }
            .cards-layout.blackjack::before {
              content: "";
              position: absolute;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              background: radial-gradient(
                ellipse 100% 44% at 50% calc(30% + 40px),
                rgba(62, 193, 65, 0.95) 0%,
                rgba(62, 193, 65, 0.8) 15%,
                rgba(30, 80, 35, 0.5) 40%,
                #1e1e1e 55%,
                #1e1e1e 100%
              );
              opacity: 0.4;
              pointer-events: none;
              z-index: 0;
            }
            .cards-layout.blackjack > * {
              position: relative;
              z-index: 1;
            }
            .blackjack {
              background: #000000 !important;
            }
            .cards-layout.blackjack .sound-icon {
              right: 18px !important;
              transform: scale(0.9);
              transform-origin: center;
            }
          }
          @media (max-width: 576px) {
            .aviator-scope .Connectedclients {
              margin-left: 10px;
            }
            .mobile-margin{
              margin-top: 8px;
            }
          }
          @scope (.aviator-scope) {
    @media (max-width: 768px) {
        .footer-divbpg > .video-button {
            display: flex !important;
        }
    }
}
          `}
      </style>
    </div>
  );
}
